<template>
  <form
    class="AddNewPaymentCardModal"
    id="payment-form"
    @submit.prevent="saveNewCard"
  >
    <h3 class="form-wrapper-body-title">Add New Payment Card</h3>
    <section class="AddNewPaymentCardModal-form">
      <div id="payment-element" />
      <template v-show="!isLoading">
        <div class="default-card-checkbox">
          <checkbox
            checkbox-id="default-method"
            v-bind:checked.sync="defaultMethod"
          >
            Make default
          </checkbox>
        </div>
        <section class="AddNewPaymentCardModal-security mt-3">
          <header class="d-flex">
            <img src="../../assets/img/svg/save.svg" alt="save" />
            <span class="AddNewPaymentCardModal-security-title"
              >Safe checkout</span
            >
          </header>
          <p class="AddNewPaymentCardModal-security-description">
            All information is encrypted and transmitted without risk.
          </p>
        </section>
      </template>
    </section>

    <div class="form-wrapper-footer">
      <button
        @click="moveBack"
        type="button"
        :class="[
          'form-wrapper-footer-button',
          'secondary-btn',
        ]"
        :style="{ width: '40%', marginRight: '1rem' }"
        :disabled="isLoading"
      >
        Back
      </button>

      <button
        id="submit"
        type="submit"
        :class="[
          'form-wrapper-footer-button',
          'primary-btn',
          isLoading && 'ie-spinner',
        ]"
        :style="{ width: '40%' }"
        :disabled="isLoading"
        v-spinner="isLoading"
      >
        Save Card
      </button>
    </div>
  </form>
</template>

<script>
import { initializeStripe } from "@/constants/stripe";
import { mapActions, mapGetters } from "vuex";
import { NotificationsTypes } from "@/constants/notificationsTypes";

const SelectPaymentCardModal = () =>
  import(
    /* webpackChunkName: "activities" */ "@/components/modals/SelectPaymentCardModal"
  );

export default {
  name: "AddNewPaymentCardModal",
  components: {
    Checkbox: () => import("@/components/controls/Checkbox"),
  },
  data() {
    return {
      isLoading: true,
      defaultMethod: false,
    };
  },
  computed: {
    ...mapGetters(["schoolInfo", "clientSecret", "payNowActivityId", "payNowEnrollmentData"]),
  },
  methods: {
    ...mapActions([
      "getClientSecret",
      "createNotification",
      "showSpinner",
      "openModal",
      "closeModal",
    ]),
    async saveNewCard() {
      try {
        this.isLoading = true;
        this.showSpinner(true);
        await this.$elements.submit();
        await this.getClientSecret();
        await this.$stripe.confirmSetup({
          elements: this.$elements,
          clientSecret: this.clientSecret.clientSecret,
          confirmParams: {
            return_url: `${window.location.href}?activityId=${this.payNowActivityId}&defaultMethod=${this.defaultMethod}&typeActivity=${this.payNowEnrollmentData.activityType}`,
          },
        });
      } catch (error) {
        this.createNotification({
          message: "Failed to save a card. Please try again.",
          type: NotificationsTypes.ERROR,
        });
      } finally {
        this.isLoading = false;
        this.showSpinner(false);
      }
    },
    initStripeElemens() {
      try {
        this.$stripe = initializeStripe(this.schoolInfo.stripeAccountId);
        this.$elements = this.$stripe.elements({
          fonts: [
            {
              cssSrc: "https://fonts.googleapis.com/css?family=Asap:400",
            },
          ],
          mode: "setup",
          currency: "usd",
        });
        const paymentElement = this.$elements.create("payment", {});
        paymentElement.mount("#payment-element");
      } catch (error) {
        this.createNotification({
          message:
            "Failed to initialize stripe elements. Please try later or contact support.",
          type: NotificationsTypes.ERROR,
        });
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 1000);
        this.showSpinner(false);
      }
    },
    moveBack() {
      this.openModal({
        modal: SelectPaymentCardModal,
        options: {
          confirmOnClose: true,
        },
      });
    },
  },
  beforeMount() {
    this.showSpinner(true);
    this.$nextTick(() => {
      this.initStripeElemens();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";

.AddNewPaymentCardModal {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;
  @media screen and (max-width: 568px) {
    width: calc(100% - 10px);
  }
  &-form {
    flex-grow: 1;
    padding: 20px;
    min-height: 555px;
  }

  &-security {
    margin-bottom: 10px;
    @media screen and (max-width: 568px) {
      margin-bottom: 5px;
    }

    &-title {
      margin-bottom: 0;
      margin-left: 10px;
      font-size: 16px;
      font-weight: 500;
      color: $Dark;
    }

    &-description {
      font-size: 14px;
      color: $Dark;
    }
  }
  .default-card-checkbox {
    margin-top: 10px;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/AddNewPaymentCardModal.vue